import { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthStore, type UserRole } from "@/features/auth";

interface Props {
  children: ReactNode;
  role?: UserRole;
}

export function RequireAuth({ children, role }: Props) {
  const location = useLocation();
  const token = useAuthStore((s) => s.token);
  const user = useAuthStore((s) => s.user);

  if (!token || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (role && user.role !== role) {
    return <Navigate to={user.role === "VENUE" ? "/venue" : "/worker"} replace />;
  }

  return <>{children}</>;
}
